import common from "../../utils/common";
import c from "../../utils/constants";
import env from "../../utils/env";
import _ from "underscore";

class BusinessDetailsController {

  constructor($stateParams, $sce, BusinessesService, AppContextService, NotificationService, $scope) {
    "ngInject"
    this.businessesService = BusinessesService;
    this.appContextService = AppContextService;
    console.log($stateParams.businessId);
    this.businessId = $stateParams.businessId;
    this.getBusinessDetails(this.businessId);
    this.deleteIntercomAccount = true;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.$sce = $sce;
  }

  $onInit() {
    this.tabTypes = {
      LEAD_DETAILS: 1,
      ACTIVITY: 2,
      NOTES: 3,
    };
  }

  businessLink() {
    if (!this.business) return "";

    return 'https://www.jugglestreet.com.au/business-details?businessId=' + this.business.id;
  }

  locationStatus() {
    if (!this.business) return '';

    return c.getLocationStatusText(this.business.locationStatus);
  }

  locationType() {
    if (!this.business) return '';

    return c.getLocationTypeText(this.business.locationType);
  }

  getBusinessDetails(businessId) {
    this.isLoading = true;

    this.businessesService.getBusinessDetails(businessId, (response) => {
      this.business = response.data;
      this.isLoading = false;

      this.getTabs();

      this.$scope.$apply();
    },
    (error) => {
      this.isLoading = false;
    })
  }

  getTabs() {
    this.tabs = {
      [this.tabTypes.LEAD_DETAILS]: {
        key: 1,
        label: "LEAD DETAILS",
        isActive: true,
        icon: "fa fa-user",
      },
      // [this.tabTypes.ACTIVITY]: {
      //   key: 2,
      //   label: "ACTIVITY",
      //   isActive: false,
      //   icon: "fa fa-user",
      // },
      // [this.tabTypes.NOTES]: {
      //   key: 3,
      //   label: "NOTES",
      //   isActive: false,
      //   icon: "fa fa-user",
      // }
    };

    this.activeTab = this.tabs["1"];
  }

  switchTab(tab) {
    this.activeTab = tab;

    Object.keys(this.tabs).map((i) => {
      if(this.tabs[i] == this.activeTab) this.tabs[i].isActive = true;
      else this.tabs[i].isActive = false;
    })
  }

  formatDate(date) {
    return common.formatDate(date);
  }

  hasGlobalAdminAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if (this.appContextService.hasGlobalAdminAccess(appContext.roles))
      return true;
    else
      return false;
  }

  hasLoginAsUserAccess() {
    const appContext = this.appContextService.getAppContext();
    if (!appContext)
      return false;

    if(this.appContextService.hasLoginAsUserAccess(appContext.roles))
      return true;
    else
      return false;
  }

  _getDialogOptions() {
    return {
      buttonLayout: "normal",
      messages:{
        close: ""
      },
      visible: false,
      closable: true,
      modal: true,
    };
  }

  handleRefreshCache() {
    let payload = { actionType: c.adminEntitiesActionType.REFRESH_CACHE }
    this.businessesService.updateUserDetails(this.businessId, payload, () => {
      this.notificationService.success("Cache refresh successful.");
    }, () => {
      this.notificationService.error("Cache refresh failed.");
    });
  }

}

export default BusinessDetailsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/business-details/business-details.controller.js
 **/